import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'full-header',
  templateUrl: './full-header.component.html',
  styleUrls: ['./full-header.component.scss']
})
export class FullHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
